import { getTenantId } from 'common/helpers/apiHelper';

import {
  isCommerce7DigitalWalletDevMode,
  isTestFullSteamDigitalWallet,
  isTestFullSteamDigitalWalletForBetaCustomers
} from './featureFlags';

export const hasPaystack = (setting) => {
  if (setting.paystack?.apiKey) {
    return true;
  }
  return false;
};

export const getStripePublishableKey = () => {
  const testKey = 'pk_test_HRpsS37F4cdftiyk5Hkov0UL';
  const liveKey = 'pk_live_BcLCiQVmR4MyVauDqLvgRk3h';

  // Tenants to have test key
  if (
    [
      'spectra-winery-demo-v2',
      'jason-demo-site-db4',
      'sandbox-stripe-payment-testing'
    ].includes(getTenantId())
  ) {
    return testKey;
  }
  if (process.env.APP_MODE === 'production') {
    return liveKey;
  }
  return testKey;
};

export const getStripeOptions = () => {
  const options = {
    hidePostalCode: true,
    style: {
      base: {
        color: getCSSVar('--c7-body-text-color'),
        backgroundColor: getCSSVar('--c7-field-bg'),
        fontFamily: getCSSVar('--c7-font-family'),
        fontSmoothing: 'antialiased',
        fontSize: getCSSVar('--c7-font-size'),
        iconColor: getCSSVar('--c7-body-text-color'),
        '::placeholder': {
          color: getCSSVar('--c7-field-placeholder')
        }
      },
      complete: {},
      empty: {},
      invalid: {
        color: getCSSVar('--c7-error'),
        iconColor: getCSSVar('--c7-error')
      }
    }
  };

  return options;
};

export const getStripeElementsOptions = () => {
  const options = {
    fonts: [
      {
        cssSrc:
          'https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap'
      }
    ]
  };
  return options;
};

export const hasCommerce7Payments = (settings) => {
  if (settings.commerce7Payments?.enabled) {
    return true;
  }
  return false;
};

export const getFullsteamDigitalWalletUrl = () => {
  if (
    process.env.APP_MODE === 'production' &&
    !isTestFullSteamDigitalWallet() &&
    isTestFullSteamDigitalWalletForBetaCustomers()
  ) {
    // prod env
    return 'https://hostedpayments.fullsteampay.net';
  }

  if (isCommerce7DigitalWalletDevMode(getTenantId())) {
    // dev env
    return 'https://hostedpayments-int.fullsteampay.net';
  }

  // test env
  return 'https://hostedpayments-ext.fullsteampay.net';
};

export const hasStripe = (settings) => {
  // DO NOT RUN STRIPE AND PAYSTACK AT THE SAME TIME
  if (settings.stripe?.accountId && !settings.paystack?.apiKey) {
    return true;
  }
  return false;
};

const getCSSVar = (cssVariable) => {
  const rawValue = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(cssVariable)
    .trim();

  // Remove special characters
  // Söhne → Sohne
  // 'á', 'à', 'â', 'ä', 'ã', 'å', 'ā' -> 'a'
  // 'é', 'è', 'ê', 'ë', 'ē', 'ė', 'ę' -> 'e'
  const sanitizedValue = rawValue.replace(/'([^']+)'|([^,]+)/g, (match) =>
    match.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  );

  return sanitizedValue;
};
